import { FetchOptions } from "../../hooks/useFetch/types";
import { HttpMethod } from "../../types/HttpMethod";

type buildFetchOptionsProps = {
  method: HttpMethod;
  options?: FetchOptions;
  signal?: AbortSignal;
  token?: string;
  skipAuth?: boolean;
};

const GENAI_SERVICE_HEADER_KEY = "x-gpc-genai-service";
const GENAI_SERVICE_HEADER_VALUE = "chatgpc-frontend";

export const buildFetchOptions = ({
  options,
  method,
  signal,
  token,
  skipAuth,
}: buildFetchOptionsProps): RequestInit => {
  const headers = new Headers(
    options?.headers || {
      "Content-Type": "application/json",
    },
  );
  headers.set(GENAI_SERVICE_HEADER_KEY, GENAI_SERVICE_HEADER_VALUE);

  const mergedOptions: FetchOptions = {
    responseType: "json",
    ...options,
  };

  const requestOptions: RequestInit = {
    method,
    signal: signal,
  };

  // Handle body based on content type and method
  if (method !== "GET" && mergedOptions.body) {
    if (mergedOptions.body instanceof FormData) {
      // Remove Content-Type header to let the browser set it with the boundary
      headers.delete("Content-Type");
      requestOptions.body = mergedOptions.body;
    } else if (typeof mergedOptions.body === "object") {
      requestOptions.body = JSON.stringify(mergedOptions.body);
    } else {
      requestOptions.body = mergedOptions.body;
    }
  }

  if (token && !skipAuth && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  requestOptions.headers = headers;
  return requestOptions;
};
